/* Fit Craver — size-guide label fix (bq-label.js)
   Added 2026-09-05.

   The theme's locale key products.product.product_size_guide is
   mistranslated: ar-IL says "سياسة الإرجاع" (return policy) and he says
   "מדיניות החזרות", when the string means SIZE GUIDE.

   The proper fix is Online Store -> Themes -> ... -> Edit default theme
   content, and change the string at source. This is a safety net so the
   wrong word can never reach a customer, wherever it is rendered.
*/
(function () {
  'use strict';

  var HE = (document.documentElement.lang || '').indexOf('he') === 0;
  var LABEL = HE ? 'טבלת מידות' : 'جدول المقاسات';

  /* every wording the mistranslation is known to produce */
  var WRONG = [
    'سياسة الإرجاع',   /* ar: "return policy"   */
    'سياسة الارجاع',   /* ar, no hamza          */
    'מדיניות החזרות'    /* he: "return policy"   */
  ];

  function fix() {
    /* the theme's own size-chart control, wherever it renders */
    var nodes = document.querySelectorAll('.t4s-btn__size-chart, .t4s-btn__size-chart span, [data-id="t4s-pr-popup__size-guide"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length) continue;            /* only leaf text nodes */
      var txt = (el.textContent || '').trim();
      for (var w = 0; w < WRONG.length; w++) {
        if (txt === WRONG[w]) { el.textContent = LABEL; break; }
      }
    }
  }

  function init() {
    fix();
    /* the theme re-renders parts of the product form on variant change */
    if (window.MutationObserver) {
      var host = document.querySelector('.t4s-product__info-container') || document.body;
      new MutationObserver(fix).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
